/**
 * Checks if the value is null, undefined or an empty string incl. string with only spaces.
 * @param value Checking value
 * @returns True if value is not valid, false otherwise
 */
export const isNotValidValue = (value: string) =>
    value === null || value === undefined || value === "" || value.replaceAll(" ", "").length === 0;
